// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"5b373f47","425":"e441a79a","510":"5b3a8da3","532":"414d80e7","633":"021c8070","634":"6d87dc64","922":"03958a89","937":"be6939b8","972":"c23af5db"}[chunkId] + ".chunk.js";
};